import TracksMenu from '../TracksMenu/TracksMenu.js';
import SubtitleTracksMenu from '../SubtitleTracksMenu/SubtitleTracksMenu.js';
import './AudioSubtitlesMenuContent.scss';
import { jsxs, jsx } from 'react/jsx-runtime';
import '../TracksMenu/TracksMenu.scss';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'react';
import 'lodash/some';

/* External */

function AudioSubtitlesMenuContent(_ref) {
  var audioTracks = _ref.audioTracks,
    onSelectAudio = _ref.onSelectAudio,
    subtitleTracks = _ref.subtitleTracks,
    onSelectSubtitle = _ref.onSelectSubtitle,
    onDisableSubtitles = _ref.onDisableSubtitles,
    audioTitle = _ref.audioTitle,
    subtitlesTitle = _ref.subtitlesTitle,
    getLanguageLabel = _ref.getLanguageLabel;
  return /*#__PURE__*/jsxs("div", {
    className: "dtv-common-c-audio-subtitles-menu-content",
    children: [/*#__PURE__*/jsx("div", {
      className: "dtv-common-c-audio-subtitles-menu-content__sub-menu-audio",
      children: /*#__PURE__*/jsx(TracksMenu, {
        title: audioTitle,
        tracks: audioTracks,
        onSelectTrack: onSelectAudio,
        getLanguageLabel: getLanguageLabel
      })
    }), /*#__PURE__*/jsx("div", {
      className: "dtv-common-c-audio-subtitles-menu-content__sub-menu-text",
      children: /*#__PURE__*/jsx(SubtitleTracksMenu, {
        tracks: subtitleTracks,
        onSelectTrack: onSelectSubtitle,
        onDisableSubtitles: onDisableSubtitles,
        title: subtitlesTitle,
        getLanguageLabel: getLanguageLabel
      })
    })]
  });
}
AudioSubtitlesMenuContent.defaultProps = {
  audioTracks: [],
  onSelectAudio: function onSelectAudio() {},
  subtitleTracks: [],
  onSelectSubtitle: function onSelectSubtitle() {},
  onDisableSubtitles: function onDisableSubtitles() {},
  audioTitle: '',
  subtitlesTitle: '',
  getLanguageLabel: function getLanguageLabel() {}
};

export { AudioSubtitlesMenuContent as default };
//# sourceMappingURL=AudioSubtitlesMenuContent.js.map
